import { Button } from "@/components/ui/button";
import { CheckCircle2, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface CampaignStatusFilterProps {
  inEffect: boolean;
  onInEffectChange: (value: boolean) => void;
}

export function CampaignStatusFilter({
  inEffect,
  onInEffectChange,
}: CampaignStatusFilterProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      className={cn(
        "h-8 border-dashed",
        inEffect ? "border-green-500 bg-green-50 text-green-700" : "text-muted-foreground"
      )}
      onClick={() => onInEffectChange(!inEffect)}
    >
      <CheckCircle2 className="mr-2 h-4 w-4" />
      Em vigência
      {inEffect && (
        <>
          <div className="mx-2 h-4 w-[1px] bg-gray-300" />
          <X
            className="h-3 w-3"
            onClick={(e) => {
              e.stopPropagation();
              onInEffectChange(false);
            }}
          />
        </>
      )}
    </Button>
  );
}
